import { Ubicacion, UbicacionForm, UbicacionUpsert } from '@models/.';
import { getCountryIsoCode, getCountryName } from './country-translator';

export function transformToData(location: Ubicacion | null): Ubicacion | null {
  if (!location) return null;
  
  return {
    ...location,
  };
}

export function transformToForm(location: Ubicacion): UbicacionForm {
  const {
    idUbicacion: id,
    direccion: address,
    mainStreet,
    crossStreet,
    ciudad: city,
    pais,
    estado: state,
    codigoPostal: postalCode,
    zonaHoraria: timezone,
  } = location;

  return {
    id,
    address,
    mainStreet,
    crossStreet,
    city,
    country: getCountryName(pais),
    state,
    postalCode,
    timezone,
  };
}

export function transformToUpsert(
  locationForm: UbicacionForm
): UbicacionUpsert {
  const {
    address: direccion,
    mainStreet: mainStreet,
    crossStreet: crossStreet,
    city: ciudad,
    country,
    state: estado,
    postalCode: codigoPostal,
    timezone: zonaHoraria,
  } = locationForm;

  return {
    direccion: direccion ?? "",
    mainStreet: mainStreet ?? "",
    crossStreet: crossStreet ?? "",
    ciudad: ciudad ?? "",
    pais: getCountryIsoCode(country) ?? "",
    estado: estado ?? "",
    codigoPostal: codigoPostal ?? "",
    zonaHoraria: zonaHoraria ?? "",
  };
}